import * as angular from 'angular';

import { FeedbackNodeModel } from './feedback-node.factory';

export const feedbackNode = angular.module('go.models.feedbackNode', [])
	.value('FeedbackNodeModel', FeedbackNodeModel)
	.name;
